import Form from 'mobx-react-form';
import { muiFormBindings } from 'forms/utils/muiFormBindings';
import { plugins } from 'forms/utils/formPlugins';
import { FieldsDefinitions } from 'mobx-react-form/lib/models/FormInterface';
import { editUser } from 'utils/labels';

const fields: FieldsDefinitions = [
  {
    name: 'password',
    label: editUser.password,
    bindings: 'TextField',
    type: 'password',
    value: '',
    rules: 'string|between:8,100',
  },
  {
    name: 'confirmPassword',
    label: editUser.confirmPassword,
    bindings: 'TextField',
    type: 'password',
    value: '',
    rules: 'same:password',
  },
  {
    name: 'email',
    label: editUser.email,
    bindings: 'TextField',
    value: '123',
    rules: 'required|email|string|between:5,100',
  },
  {
    name: 'plan',
    label: editUser.plan,
    bindings: 'TextField', // not using Select
    value: '',
    rules: 'required|string',
  },
  {
    name: 'planExpiration',
    label: editUser.planExpiration,
    bindings: 'DatePicker',
    value: '',
    rules: 'moment',
  },
  {
    name: 'planRenews',
    label: editUser.planRenews,
    bindings: 'Checkbox',
    value: false,
  },
  {
    name: 'planProducts',
    label: editUser.planProducts,
    bindings: 'Select',
    value: [],
  },
  {
    name: 'paymentCustomerId',
    label: editUser.paymentCustomerId,
    bindings: 'TextField',
    value: '',
    rules: 'string',
  },
  {
    name: 'enabled',
    label: editUser.enabled,
    bindings: 'Checkbox',
    value: true,
  },
  {
    name: 'admin',
    label: editUser.admin,
    bindings: 'Checkbox',
    value: false,
  },
];

const hooks = {};

const formOptions = {
  validationDebounceWait: 0,
  showErrorsOnReset: false,
};

export function createForm() {
  return new Form(
    { fields },
    { plugins, hooks, bindings: muiFormBindings, options: formOptions },
  );
}
